import { useLayoutEffect, useRef, useState } from "react";

const STORAGE_KEY = "clank.sidebar.collapsed";

export function useSidebarCollapsed(isProcessDetail: boolean) {
  const [savedCollapsed] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });
  const preferredCollapsed = useRef(savedCollapsed);
  const [collapsed, setCollapsed] = useState(isProcessDetail || savedCollapsed);

  // Process maps temporarily get more room; only manual toggles change the preference.
  useLayoutEffect(() => {
    setCollapsed(isProcessDetail || preferredCollapsed.current);
  }, [isProcessDetail]);

  const toggleCollapsed = () => {
    const next = !collapsed;
    preferredCollapsed.current = next;
    setCollapsed(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // Keep the toggle working when browser storage is unavailable.
    }
  };

  return { sidebarCollapsed: collapsed, toggleSidebarCollapsed: toggleCollapsed };
}
